// Sentry doit être importé en premier pour capturer les erreurs d'init React.
import "./sentry";
import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import {
  Toaster,
  TooltipProvider,
  initColorThemeFromStorage,
  registerChunkLoadRecovery,
  resetChunkReloadAttempts,
} from "@cliently/ui";
import { Analytics } from "@vercel/analytics/react";
import { App } from "./App";
import { ErrorBoundary } from "@cliently/ui";
import { isAuthV2 } from "@cliently/auth-client";
import "./i18n";
import "./index.css";

initColorThemeFromStorage();
registerChunkLoadRecovery();
resetChunkReloadAttempts();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

const root = createRoot(document.getElementById("root")!);

const renderShell = (children: ReactNode) =>
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter unstable_useTransitions={false}>
          <TooltipProvider delayDuration={200}>
            <ErrorBoundary>
              {children}
              <Toaster />
              <Analytics />
            </ErrorBoundary>
          </TooltipProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  );

if (isAuthV2()) {
  renderShell(<App />);
} else {
  const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

  if (clerkPubKey) {
    renderShell(
      <ClerkProvider publishableKey={clerkPubKey}>
        <App />
      </ClerkProvider>,
    );
  }
}
